var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.fn}},[_c('inline-svg',{style:(`stroke: ${_vm.strokeColor}`),attrs:{"src":require(`@/assets/svg/icons/${_vm.name}.svg`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }